import { cn } from '@shared/lib/cn';
import type { MediaLink } from '../types';

export function MediaImage({
  link,
  alt,
  className,
}: {
  link: MediaLink | null | undefined;
  alt?: string;
  className?: string;
}) {
  if (!link?.url) {
    return (
      <div
        className={cn(
          'flex items-center justify-center bg-muted text-[10px] uppercase text-muted-foreground',
          className,
        )}
        aria-label="no media"
      />
    );
  }
  return <img src={link.url} alt={alt ?? ''} className={className} />;
}
